






















import { Component, Mixins, Prop, Vue } from "vue-property-decorator";
import { ITeacher } from "@/models/interfaces/teachers";

import BaseButton from "@/components/BaseButton/BaseButton.vue";
import TeachersTable from "@/components/TeachersTable/TeachersTable.vue";
import amplitude from "amplitude-js";
import { eventCodeByName, EventsNames } from "@/analytics";

@Component({
  components: {
    BaseButton,
    TeachersTable
  }
})
export default class ClassAddStep3 extends Vue {
  @Prop({ required: true, type: Array })
  private teachers!: ITeacher[];

  @Prop({ type: Array })
  private initialData!: string[];

  private selectedTeachersIds: string[] = [];

  private assignTeachers() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksNextOnStep3Class)} ${
          EventsNames.UserClicksNextOnStep3Class
        }`
      );

    this.$emit("on-next", this.selectedTeachersIds);
  }

  private setTeachers(data: string[]) {
    this.selectedTeachersIds = data;
  }

  public mounted() {
    this.selectedTeachersIds = this.initialData || [];
  }
}
